import { createStore } from 'vuex';
import axios from 'axios';
import VuexPersistence from 'vuex-persist'

const store = createStore({
    state: {
    // url: 'http://localhost:8000/',
    url: 'https://unionfederationbd.com/',
    federationId:0,  
    federationName:"RDRS",  
    },
    mutations: {
    SET_EVENT_VALUE(state, { value, text }) {
      state.federationId = value;
      state.federationName = text;
      if(state.federationId==0){
        localStorage.clear(); 
      }
    },
    },
    
    actions: {
      updateEventValue({ commit }, { value, text }) {
        commit("SET_EVENT_VALUE", { value, text });
      },
    },
    getters: {
     
    },
    plugins: [new VuexPersistence().plugin]

});

export default store;
